/**
 * Credit status (Story 16.4) — `GET ${VITE_HARNESS_BASE_URL}/api/credit/status`.
 *
 * Role-open: `ok | low | exhausted` plus whether the low-balance warning is
 * configured. It never carries the balance (members are never shown one).
 *
 * Goes through the shared `harnessClient`, not bare axios: this read is POLLED
 * (`useCreditStatus`, every 60s), and only the shared interceptor replays a 401
 * through the token refresh. A bare call 401s from the moment the 30-minute
 * access token expires until AuthContext's 5-minute sweep notices — and since
 * an error hides the banner, a low or exhausted banner would blink out on an
 * idle tab once per token cycle. `skipErrorToast` because the banner renders
 * nothing on a failure: a toast per failed poll would be the only symptom.
 */

import { harnessClient } from '@/lib/api/client';

export type CreditState = 'ok' | 'low' | 'exhausted';

export interface CreditStatus {
  state: CreditState;
  warningEnabled: boolean;
}

/** Path on the harness — exposed for unit tests. */
export const CREDIT_STATUS_PATH = '/api/credit/status';

export async function fetchCreditStatus(signal?: AbortSignal): Promise<CreditStatus> {
  const res = await harnessClient.get<CreditStatus>(CREDIT_STATUS_PATH, {
    signal,
    skipErrorToast: true,
  });
  return res.data;
}
